import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { HushedFrame } from '../screens/auth/HushedFrame';
import { ConnectedPage } from '../screens/device/ConnectedPage';

const searchSchema = z.object({
  /** Paige Scan could not exchange its code; only `1` means so. Kept as given, so the URL stays as it came. */
  failed: z.union([z.string(), z.number()]).optional().catch(undefined),
});

/**
 * Where Paige Scan sends the browser after connecting (docs/engineering/folder-monitor.md, section 7).
 * No sign-in: the page only says, in fixed words, whether it worked.
 */
export const Route = createFileRoute('/device_/connected')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { failed } = Route.useSearch();
  return (
    <HushedFrame>
      <ConnectedPage failed={String(failed) === '1'} />
    </HushedFrame>
  );
}
